import { useState } from "react";
import { PhoneInput } from "types/common";

interface ProductLinkDataState {
  title: string | null;
  subtitle: string | null;
  amount: number;
  amountDisplay: number;
  productData: any;
  isLoading: boolean;
  productLinkData: any;
  editVal: number;
  prodPermission: ProdPermission;
  isProdLinkActive: boolean;
  phoneNumber: PhoneInput;
  upsellPriceData: any;
  enabled: boolean;
}

interface UseProductLinkDataReturn extends ProductLinkDataState {
  setTitle: (title: string | null) => void;
  setSubtitle: (subtitle: string | null) => void;
  setAmount: (amount: number) => void;
  setAmountDisplay: (amount: number) => void;
  setProductData: (data: any) => void;
  setIsLoading: (loading: boolean) => void;
  setProductLinkData: (data: any) => void;
  setEditVal: (val: number) => void;
  setProdPermission: (permission: ProdPermission) => void;
  setIsProdLinkActive: (active: boolean) => void;
  setPhoneNumber: React.Dispatch<React.SetStateAction<PhoneInput>>;
  setUpsellPriceData: (data: any) => void;
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

type ProdPermission = {
  collect_address: "Y" | "N" | string;
  collect_phone: "Y" | "N" | string;
  custom_conv: "Y" | "N" | string;
};

export const useProductLinkData = (): UseProductLinkDataReturn => {
  const [title, setTitle] = useState<string | null>(null);
  const [subtitle, setSubtitle] = useState<string | null>(null);
  const [amount, setAmount] = useState<number>(0);
  const [amountDisplay, setAmountDisplay] = useState<number>(0);
  const [productData, setProductData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isProdLinkActive, setIsProdLinkActive] = useState<boolean>(true);
  const [productLinkData, setProductLinkData] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState<PhoneInput>({
    phone: "",
    postal_code: "",
    country_code: "",
  });
  const [upsellPriceData, setUpsellPriceData] = useState<any>(null);
  const [prodPermission, setProdPermission] = useState<ProdPermission>({
    collect_address: "",
    collect_phone: "",
    custom_conv: "",
  });
  const [editVal, setEditVal] = useState(0);
  const [enabled, setEnabled] = useState(false);

  return {
    title,
    subtitle,
    amount,
    amountDisplay,
    productData,
    upsellPriceData,
    isLoading,
    productLinkData,
    editVal,
    isProdLinkActive,
    prodPermission,
    phoneNumber,
    enabled,
    setEnabled,
    setUpsellPriceData,
    setPhoneNumber,
    setIsProdLinkActive,
    setTitle,
    setSubtitle,
    setAmount,
    setAmountDisplay,
    setProductData,
    setIsLoading,
    setProductLinkData,
    setProdPermission,
    setEditVal,
  };
};
